import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FaBrain, FaCog, FaChartLine, FaMicrochip, FaRobot, FaAtom } from 'react-icons/fa';
import styles from './Research.module.css';

const Research: React.FC = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const expertiseAreas = [
    { icon: <FaAtom />, title: 'Aerospace', description: 'Materials & diagnostics' },
    { icon: <FaChartLine />, title: 'Signal Processing', description: 'AE & vibration' },
    { icon: <FaBrain />, title: 'AI & Data Science', description: 'Deep learning' },
    { icon: <FaCog />, title: 'Predictive Maintenance', description: 'Real-time SHM' },
    { icon: <FaRobot />, title: 'Condition Monitoring', description: 'Smart diagnostics' },
    { icon: <FaMicrochip />, title: 'Geospatial AI', description: 'Remote sensing' },
  ];

  return (
    <section id="research" className={styles.research} ref={ref}>
      <div className={styles.container}>
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className={styles.header}
        >
          <h2 className={styles.title}>Research</h2>
          <div className={styles.titleUnderline}></div>
        </motion.div>

        <div className={styles.expertiseGrid}>
          {expertiseAreas.map((area, index) => (
            <motion.div
              key={index}
              className={styles.expertiseCard}
              initial={{ opacity: 0, y: 50 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <div className={styles.iconWrapper}>
                {area.icon}
              </div>
              <h3 className={styles.cardTitle}>{area.title}</h3>
              <p className={styles.cardDescription}>{area.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Research;
